export {
    default as image
} from "./image.glsl.js";
